import { type PropsWithChildren, type CSSProperties } from 'react';
import { twMerge } from 'tailwind-merge';
import { classes } from './utils';

export interface CardProps extends PropsWithChildren {
  className?: string;
  style?: CSSProperties;
}

export default function Card({ className, style, children }: CardProps) {
  return (
    <div className={twMerge(classes.card, className)} style={style}>
      {children}
    </div>
  );
}
